export const iconFontAwesomeMediaplaybackPlay = (
	<i className="fa-solid fa-play"></i>
);
